import { useMutation, useQueryClient } from '@tanstack/react-query';
import { transactionDocumentService } from '@/services/transactionDocumentService';

interface UploadTransactionDocumentArgs {
  transactionId: string;
  file: File;
}

export const useUploadTransactionDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transactionId, file }: UploadTransactionDocumentArgs) => {
      return transactionDocumentService.uploadDocument(transactionId, file);
    },
    onSuccess: () => {
      // Invalidate transaction log queries to refresh document list
      void queryClient.invalidateQueries({
        queryKey: ['transaction-log'],
      });
    },
  });
};
